import { render, staticRenderFns } from "./ExRetireOrgObject.vue?vue&type=template&id=2fae84cb"
import script from "./ExRetireOrgObject.vue?vue&type=script&lang=js"
export * from "./ExRetireOrgObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports